const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;
const BANGKOK_UTC_OFFSET_MILLISECONDS = 7 * 60 * 60 * 1000;

const toDate = (value) => {
  if (!value) return null;

  try {
    if (typeof value.toDate === "function") {
      return value.toDate();
    }

    if (value instanceof Date) {
      return value;
    }

    if (typeof value.seconds === "number") {
      const nanoseconds = Number(value.nanoseconds) || 0;
      return new Date(value.seconds * 1000 + Math.floor(nanoseconds / 1e6));
    }

    const parsedDate = new Date(value);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
  } catch {
    return null;
  }
};

const getBangkokDateParts = (value) => {
  const date = toDate(value);
  if (!date || Number.isNaN(date.getTime())) return null;

  // Thailand stays at UTC+7 year-round. Shifting first and then reading UTC
  // fields makes calendar dates independent from the viewer's OS time zone.
  const bangkokDate = new Date(
    date.getTime() + BANGKOK_UTC_OFFSET_MILLISECONDS,
  );

  return {
    year: bangkokDate.getUTCFullYear(),
    month: bangkokDate.getUTCMonth() + 1,
    day: bangkokDate.getUTCDate(),
  };
};

const toUtcDayNumber = ({ year, month, day }) =>
  Date.UTC(year, month - 1, day) / MILLISECONDS_PER_DAY;

export const formatCpapTrialDueDate = (value) => {
  const parts = getBangkokDateParts(value);
  if (!parts) return "-";

  return `${parts.day}-${parts.month}-${parts.year}`;
};

export const getCpapTrialDaysLate = (dueDateValue, now = new Date()) => {
  const dueDateParts = getBangkokDateParts(dueDateValue);
  const todayParts = getBangkokDateParts(now);

  if (!dueDateParts || !todayParts) return "-";

  return toUtcDayNumber(todayParts) - toUtcDayNumber(dueDateParts);
};
